import React from 'react';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';
import { useProducts } from '../hooks/useProducts';

interface ProductsLoaderProps {
  children: React.ReactNode;
  showError?: boolean;
}

export const ProductsLoader: React.FC<ProductsLoaderProps> = ({ 
  children, 
  showError = true 
}) => {
  const { loading, error, productsLoaded } = useProducts();

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="200px"
        gap={2}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" color="text.secondary">
          Loading products...
        </Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center">
          Loading {productsLoaded ? 'additional' : ''} product data
          <br />
          This may take a few moments
        </Typography>
      </Box>
    );
  }

  if (error && showError) {
    return (
      <Box p={2}>
        <Alert severity="error">
          <Typography variant="h6">Failed to load products</Typography>
          <Typography variant="body2">{error}</Typography>
        </Alert>
      </Box>
    );
  }

  return <>{children}</>;
};
